import { Shield } from 'lucide-react';

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 bg-teal-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Shield className="w-8 h-8 text-teal-600" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Privacy Policy
          </h1>
          <p className="text-lg text-slate-600">
            Last updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
          <h2>Introduction</h2>
          <p>
            DME R'US ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
            explains how we collect, use, disclose, and safeguard your information when you use our 
            HIPAA-compliant durable medical equipment management platform.
          </p>

          <h2>Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>We may collect personal information that you voluntarily provide, including:</p>
          <ul>
            <li>Name, email address, and phone number</li>
            <li>Company name and job title</li>
            <li>Billing and payment information</li>
            <li>Communication preferences</li>
          </ul>

          <h3>Protected Health Information (PHI)</h3>
          <p>
            As a HIPAA-compliant platform, we may process PHI on behalf of our customers. This includes 
            patient demographics, medical records, insurance information, and prescription data. All PHI 
            is handled in accordance with HIPAA regulations.
          </p>

          <h2>How We Use Your Information</h2>
          <p>We use collected information to:</p>
          <ul>
            <li>Provide and maintain our services</li>
            <li>Process transactions and send related information</li>
            <li>Send administrative information and updates</li>
            <li>Respond to inquiries and provide customer support</li>
            <li>Improve our platform and develop new features</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>Data Security</h2>
          <p>
            We implement enterprise-grade security measures including:
          </p>
          <ul>
            <li>End-to-end encryption for data in transit and at rest</li>
            <li>Role-based access control (RBAC)</li>
            <li>Complete audit logging of all system activities</li>
            <li>Secure cloud storage with iDrive E2 (S3-compatible)</li>
            <li>Regular security assessments and penetration testing</li>
          </ul>

          <h2>HIPAA Compliance</h2>
          <p>
            DME R'US maintains full HIPAA compliance. We execute Business Associate Agreements (BAAs) 
            with all customers who process PHI through our platform. Our security measures meet or 
            exceed HIPAA Security Rule requirements.
          </p>

          <h2>Data Retention</h2>
          <p>
            We retain personal information for as long as necessary to fulfill the purposes outlined 
            in this policy, unless a longer retention period is required by law. PHI retention is 
            governed by applicable healthcare regulations and customer agreements.
          </p>

          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
            <li>Request data portability</li>
          </ul>

          <h2>Contact Us</h2>
          <p>
            For questions about this Privacy Policy or our data practices, please contact our 
            Privacy Officer at:
          </p>
          <ul>
            <li>Email: privacy@dmerus.com</li>
            <li>Phone: 1-800-DME-HELP</li>
            <li>Address: 11161 E State Rd 70, Ste 110-556, Lakewood Ranch, FL 34202</li>
          </ul>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes 
            by posting the new policy on this page and updating the "Last updated" date.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
